import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { useMemo } from 'react';
import { RfpProfessionalNegotiateContent, RfpProfessionalNegotiateSkeleton, } from '@/components/modules/pages/rfp/professional/Content/RfpProfessionalNegotiateContent';
import { RfpProfessionalOneApprovedContainer } from '@/components/modules/pages/rfp/professional/Layout/RfpProfessionalOneApprovedContainer/RfpProfessionalOneApprovedContainer';
import { rfpProOneTabValueNegotiate } from '@/components/modules/pages/rfp/professional/tab/RfpProOneTab';
import { getIsOfferDisabled } from '@/utils/modules/rfp/professional/isOfferDisabled';
import { myPagePath, professionalRfpListPath } from '@/utils/router/links';
/** パンくずリスト */
const baseBreadcrumbs = [
    {
        link: myPagePath(),
        text: 'マイページ',
    },
    {
        link: professionalRfpListPath(),
        text: '募集中のプロジェクト',
    },
];
/**
 * コンサルタント：案件詳細（条件相談）のコンテンツ部分を表示するコンポーネント
 * @constructor
 */
export const ProfessionalRfpNegotiateView = (props) => {
    const { displayLastMessage, isAdminUser, negotiate, onClickSubmit, professionalId, rfp, user, } = props;
    /** メッセージ送信可能か */
    const isShowForm = useMemo(() => {
        const isOfferDisabled = getIsOfferDisabled({
            hasOffer: rfp.has_offer,
            ignoreCallEndDate: rfp.is_calling,
            isCalling: rfp.ignore_call_end_date,
        });
        return !isOfferDisabled;
    }, [rfp]);
    return (_jsx(RfpProfessionalOneApprovedContainer, Object.assign({ activeTab: rfpProOneTabValueNegotiate, breadcrumbs: [...baseBreadcrumbs, { text: rfp.name }], isAdminUser: isAdminUser, professionalId: professionalId, rfp: rfp }, { children: negotiate ? (_jsx(RfpProfessionalNegotiateContent, { budget: rfp.budget, budgetNegotiate: negotiate.budget_negotiate, displayLastMessage: displayLastMessage, endDate: rfp.end_date, endDateNegotiate: negotiate.end_date_negotiate, isShowForm: isShowForm, maxBudget: rfp.max_budget, onClickSubmit: onClickSubmit, startDate: rfp.start_date, startDateNegotiate: negotiate.start_date_negotiate, user: user })) : (_jsx(RfpProfessionalNegotiateSkeleton, {})) })));
};
